import _ from 'lodash';
import moment from 'moment';
import fetchReassignEsimHistories from '../../../services/apollo/func/fetch/fetchReassignEsimHistories';

export const formatReassignEsimHistoris = data => data.map(esim => ({
  key: esim.id,
  id: esim.id,
  eID: esim?.esimId || '--',
  dateTime: esim.createdAt ? moment(esim.createdAt).format('DD/MM/YYYY - HH:mm:ss') : '--',
  preAssignedAccount: esim?.oldUser?.email || '--',
  newAccount: esim?.newUser?.email || '--',
  reassignedBy: `${esim?.actionBy?.firstName} ${esim?.actionBy?.lastName}`,
}));

export const getReassignEIDTableColumns = () => {
  const columns = [
    {
      title: 'Date and time',
      dataIndex: 'dateTime',
      key: 'dateTime',
    },
    {
      title: 'eID',
      dataIndex: 'eID',
      key: 'eID',
    },
    {
      title: 'Previously assigned account',
      dataIndex: 'preAssignedAccount',
      key: 'preAssignedAccount',
    },
    {
      title: 'New account',
      dataIndex: 'newAccount',
      key: 'newAccount',
    },
    {
      title: 'Reassigned by',
      dataIndex: 'reassignedBy',
      key: 'reassignedBy',
    },
  ];
  return columns;
};

export const getReassignEIDSearchBy = () => {
  const searchBy = [
    {
      label: 'eID',
      value: 'esimId',
    },
  ];
  return searchBy;
};

export const handleFetchReassignHistories = async (filter, limit) => {
  try {
    const reassignHistories = await fetchReassignEsimHistories({ filter, limit });
    if (!_.isEmpty(reassignHistories)) { return formatReassignEsimHistoris(reassignHistories); }
    return [];
  } catch (err) {
    return [];
  }
};
